import Pill from 'ext-ui/components/Pill/Pill'
import React from 'react'
import { useSelector } from 'react-redux'
import BrandLogoIcon from 'src/components/BrandMarkLogo/BrandLogoIcon'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import RejectionNotice from 'src/feature/ManagerReview/RejectionNotice/RejectionNotice'
import { useTranslate } from 'src/localization/Trns'
import {
  TransactionDetailModel,
  TransactionManagerReviewStatus,
  transactionManagerReviewStatusToColor,
  transactionManagerReviewStatusToIcon,
  transactionManagerReviewStatusToString,
} from 'src/models/transaction.models'
import { useQueryUser } from 'src/queries/users.queries'
import { selectAppName } from 'src/redux/selectors/session.selectors'

import style from './ManagerReviewSection.style'

interface ManagerReviewSectionProps {
  transaction: TransactionDetailModel
}

const ManagerReviewSection: React.FC<ManagerReviewSectionProps> = ({
  transaction,
}): React.ReactElement => {
  const translate = useTranslate()
  const appName = useSelector(selectAppName)

  const managerId = transaction?.managerReviewId || transaction.managerId
  const { data: manager } = useQueryUser({
    userId: managerId,
  })

  return (
    <div css={style} className={'managerReviewSection'}>
      <div className={'font-h3'}>{translate('Manager Review')}</div>
      <div className={'managerReviewSection-content'}>
        {transaction.managerReviewStatus ===
          TransactionManagerReviewStatus.Rejected && (
          <RejectionNotice transaction={transaction} />
        )}
        <div className={'managerReviewSection-content-list'}>
          <div className={'flex-column w-full'}>
            <div className={'flex-row justify-between'}>
              <span className={'font-form-label'}>
                {translate('Manager Review Status')}
              </span>
              {managerId === undefined ? (
                <span>{'--'}</span>
              ) : (
                <Pill
                  color={transactionManagerReviewStatusToColor(
                    transaction.managerReviewStatus,
                  )}
                >
                  <span className={'flex-row gap-1 align-center'}>
                    {transactionManagerReviewStatusToIcon(
                      transaction.managerReviewStatus,
                    )}
                    {translate(
                      transactionManagerReviewStatusToString(
                        transaction.managerReviewStatus,
                      ),
                    )}
                  </span>
                </Pill>
              )}
            </div>
          </div>
          <div className={'flex-column w-full'}>
            <div className={'flex-row justify-between'}>
              <span className={'font-form-label'}>
                {translate(
                  transaction.managerReviewStatus === undefined ||
                    transaction.managerReviewStatus ===
                      TransactionManagerReviewStatus.PendingReview
                    ? 'Awaiting Review By'
                    : 'Reviewed By',
                )}
              </span>
              <div
                className={
                  'font-regular text-primary flex-row gap-2 align-center'
                }
              >
                {managerId === undefined ? (
                  <span>{translate('Unassigned')}</span>
                ) : transaction.managerReviewStatus ===
                  TransactionManagerReviewStatus.AutoReviewed ? (
                  <>
                    <BrandLogoIcon size={24} />
                    {appName}
                  </>
                ) : (
                  manager && (
                    <>
                      <UserAvatar user={manager} size={AvatarSizes.Small24} />
                      {manager.fullNameOrEmail}
                    </>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManagerReviewSection
